export class UserHandlerService {
	constructor($http, $httpParamSerializerJQLike, CommonConstants, $rootScope) {
		'ngInject';
		this.$http = $http;
		this.$rootScope = $rootScope;
		this.constant = CommonConstants;
		this.publiRoot = '/public';
		this.privateRoot = '/private';
		this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	}

	// nem kell, shima teszi bele az oldalba, "userInfo" változóba
	/* getProfile() {
		return this.$http.get(`${this.privateRoot}/profile`);
	}*/

	login(params) {
		return this.$http({
			data: this.$httpParamSerializerJQLike(params),
			method: 'POST',
			url: `${this.constant.SZIKRA_URL}/portal/login`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}

	registration(params) {
		return this.$http({
			data: this.$httpParamSerializerJQLike(params),
			method: 'POST',
			url: `${this.constant.SZIKRA_URL}/portal/registration`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}

	logout() {
		let params = {
			userId: this.$rootScope.userInfo.userId,
			callback: window.location.origin + '/logout'
		};
		return this.$http({
			data: this.$httpParamSerializerJQLike(params),
			method: 'POST',
			url: `${this.constant.SZIKRA_URL}/portal/portallogout`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}

	saveNameAndEmail(params) {
		return this.$http({
			data: this.$httpParamSerializerJQLike(params),
			method: 'POST',
			url: `${this.constant.SZIKRA_URL}/portal/portalDataChange`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}

	saveNewPassword(params) {
		return this.$http({
			data: this.$httpParamSerializerJQLike(params),
			method: 'POST',
			url: `${this.constant.SZIKRA_URL}/portal/passwordChange`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}

	forgotPassword(params) {
		return this.$http({
			data: this.$httpParamSerializerJQLike(params),
			method: 'POST',
			url: `${this.constant.SZIKRA_URL}/portal/forgotPassword`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}
}
